import { useEffect } from 'react';

import {
  JWT,
  REFRESH_TOKEN,
  DEMO_STUDENT_JWT,
  DEMO_STUDENT_REFRESH_TOKEN,
} from 'constants/system';

const getDemoingAsStudentInThisTab = () =>
  sessionStorage.getItem(`SESSION_${JWT}_KEY`) === DEMO_STUDENT_JWT;

const getDemoingAsStudentInAnyTab = () =>
  !!localStorage.getItem('studentPreviewCounselor');

export const captureATagClicks = e => {
  // click was not on a A tag, do nothing
  if (!e.target.closest(`a`)) {
    return;
  }

  // link not opening in a new tab, do nothing
  if (e?.target?.target !== '_blank') {
    return;
  }

  // we are not currently demoing as a student, do nothing
  if (!getDemoingAsStudentInThisTab()) {
    return;
  }

  // prevent default action
  e.preventDefault();

  const newWindow = window.open(e.target.href, '_blank');
  // setting boolean for new window to know it is demoing as a student
  newWindow.demoingAsStudent = true;
};

const captureNewTabClicks = () => {
  // check to ensure we dont subscribe to listeners multiple times
  if (window.capturingNewTabClicks) {
    return;
  }
  window.capturingNewTabClicks = true;

  // capturing the window.open button to inject custom logic
  window.saveOpen = window.open;

  window.open = (url, windowName = '', params = '') => {
    // not opening a new tab, can use default logic
    if (windowName !== '_blank') {
      return window.saveOpen(url, windowName, params);
    }

    const demoingAsStudent = getDemoingAsStudentInThisTab();

    // not demoing as student, can use default logic
    if (!demoingAsStudent) {
      return window.saveOpen(url, windowName, params);
    }

    const newWindow = window.saveOpen(url, windowName, params);
    // setting boolean for new window to know it is demoing as a student
    newWindow.demoingAsStudent = true;
    return newWindow;
  };

  document.addEventListener('click', captureATagClicks);
};

export const stopCaptureNewTabClicks = () => {
  // check to ensure we dont unsubscribe to listeners multiple times
  if (!window.capturingNewTabClicks) {
    return;
  }
  window.capturingNewTabClicks = false;

  window.open = window.saveOpen;
  document.removeEventListener('click', captureATagClicks);
};

// checks if we are demoing as a student in another tab, and will update session to keep the demo
const useStudentDemoCheck = () => {
  useEffect(() => {
    // if we navigated directly, we want to continue without demoing
    // allowing counselor's to demo in one tab and see their own view in a new tab
    if (!document.referrer) {
      return;
    }

    // we are not demoing in another tab, no action needed
    if (!getDemoingAsStudentInAnyTab()) {
      return;
    }

    // we are demoing in this tab correctly, no action needed
    if (getDemoingAsStudentInThisTab()) {
      captureNewTabClicks(); // since we are demoing as a student we need to watch for any new tabs being open
      return;
    }

    // we did not come from a link from a tab where we are demoing as a student, no action needed
    // demoingAsStudent is set in the event listeners above when demoing as a student
    if (!window.demoingAsStudent) {
      return;
    }

    /*
       we now know
       - we are got to this page from a link in a tab where we were demoing as a student
       - we are demoing as a student in another tab
       
       so we want to continuing demoing as a student
    */

    // set needed session data
    sessionStorage.setItem(`SESSION_${JWT}_KEY`, DEMO_STUDENT_JWT);
    sessionStorage.setItem(
      `SESSION_${REFRESH_TOKEN}_KEY`,
      DEMO_STUDENT_REFRESH_TOKEN,
    );
    // since we are demoing as a student we need to watch for any new tabs being open
    captureNewTabClicks();
  }, []);
};

export default useStudentDemoCheck;
